import { Route, Routes } from 'react-router'

import HeyNicChat from './HeyNicChat'
import HeyNicGate from './HeyNicGate'

// Standalone /hey-nic/* routing. HeyNicGate applies the feature-flag +
// AI-availability guard; HeyNicChat then renders the focused chat experience.
function HeyNicRoutes() {
  return (
    <HeyNicGate>
      <Routes>
        <Route path='*' element={<HeyNicChat />} />
      </Routes>
    </HeyNicGate>
  )
}

export default HeyNicRoutes
